// 在url中加入transition=none，那所有页面就关闭动画切入切出效果
const shouldUseTransition = !/transition=none/.test(window.location.href)
const state = {
  direction: shouldUseTransition ? 'forward' : ''
}

const getters = {}

const actions = {}

const mutations = {
  updateDirection (state, payload) {
    if (!shouldUseTransition) {
      return
    }
    state.direction = payload.direction
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transition/index.js